import { useCallback, useState } from "react";
import { DomainObjectMeta, ValidationState } from "../lib";
import { isNullish } from "../lib/util/common-util";

export function useDomainObjectValidation<
  T,
  DO extends DomainObjectMeta<any, any, any>,
>(
  value: T | null | undefined,
  domainObjectMeta: DO,
  onValidate?: (validationStatus: ValidationState<T>) => void,
  /**
   * trueなら、nullishの場合にバリデーションを行わず、not_yetを返す。
   */
  skipValidationIfNullish: boolean = false,
) {
  const [validationState, setValidationState] = useState<ValidationState<T>>({
    state: "not_yet",
  });
  const validate = useCallback(() => {
    if (skipValidationIfNullish && isNullish(value)) {
      setValidationState({ state: "not_yet" });
      onValidate?.({ state: "not_yet" });
      return;
    }
    const _validationStatus = domainObjectMeta.validate(value);
    setValidationState(_validationStatus);
    onValidate?.(_validationStatus);
  }, [skipValidationIfNullish, domainObjectMeta, value, onValidate]);

  return {
    validate,
    validationState,
  };
}
